export const mapUserType = {
   teacher: 'profesor',
   student: 'estudiante',
   staff: 'staff',
   director: 'director'
}